import React from 'react';
import './Componenst.css';
import DocumentModel from '../models/DocumentModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createDoc, showError } from '../ViewCreator';

function Document({ changeSearch, searchModel, setView, addNew = () => {}, isAdd = false }) {

    const personModel = new DocumentModel();


    const clearSubmit = () => {
        document.getElementById('descDocument').value     = '';
        document.getElementById('seriaDocument').value     = '';
        document.getElementById('numberDocument').value     = '';
        document.getElementById('typeDocument').value     = '';
        personModel.descDocument = ''
        personModel.seriaDocument = ''
        personModel.numberDocument = ''
        personModel.typeDocument = ''
        if (searchModel != undefined ) {
          searchModel.document.descDocument = ''
          searchModel.document.seriaDocument = ''
          searchModel.document.numberDocument = ''
          searchModel.document.typeDocument = ''
        }
    }

    const addSubmit = () => {
        if (personModel.typeDocument == undefined || personModel.typeDocument == '') {
            showError('Тип не може бути пустим')
            return;
        }

        if (personModel.seriaDocument == undefined || personModel.seriaDocument == '') {
            showError('Серія не може бути пустою')
            return;
        }

        if (personModel.numberDocument == undefined || personModel.numberDocument == '') {
            showError('Номер не може бути пустим')
            return;
        }

          isUniq()
    }

    const isUniq = () => {
        var path = ip + '/api/document/search';
        personModel.searchModel = new SearchModel()
        var pp = new DocumentModel();
        pp.typeDocument = personModel.typeDocument
        pp.seriaDocument = personModel.seriaDocument
        pp.numberDocument = personModel.numberDocument
        var bd = encryptAes(JSON.stringify(pp))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
    
              if (result.data.length > 0) {
                Swal.fire({
                    title: 'Запис уже існує',
                    //text: "Оновити інформацію?",
                    icon: 'warning',
                    html:
                    'Запис з такими даними вже існує, Ви можете ' +
                    '<a href="/document?id='+result.data[0].id+'" style="color:#FFFFFF;"  target="_blank">переглянути запис</a>',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: 'ОК',
                      denyButtonText: 'Оновити',
                      background: '#2B2B2B',
                      color: '#FFF'
                    }).then((result) => {
                    })
                  sendSearch()
              } else {
                Swal.fire({
                  title: 'Ви дійсно бажаєте створити новий запис',
                  //text: "Оновити інформацію?",
                  icon: 'question',
                  html:
                  '',
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: 'Створити',
                  denyButtonText: 'Оновити',
    
                  background: '#2B2B2B',
                  color: '#FFF'
                }).then((result) => {
                  addNewDocumnet()
                  })
                
              }
            }
          })
      }

      const addNewDocumnet = () => {
        var path = ip + '/api/document/add';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
              
    
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
              if (isAdd) {
                addNew(result.data, 20005)
                clearSubmit()
              } else {
              window.open("/edit/document?id="+result.data, "_self")
              }
            }
          })
      }


    const sendDocumentFullScreen = (id) => {
        window.open("/document?id=" + id)
    }

    const sendDocument = (id) => {
        var path = ip + '/api/document/id';
       var bd = encryptAes(id)
           const requestOptions = {
             headers: {
               'Content-Type': 'Content-type: text/html; charset=win1251'
             },
             credentials: 'include',
             uri: path,
             encoding: 'latin1',
             body: bd,
             method: 'POST'
           };
           fetch(path, requestOptions)
           .then()
           .then(response => { return response.arrayBuffer() })
           .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []
                
                    var addr = result.data
                    
                    zz.push(createDoc(addr))
    
                   
                    setView(zz)
                }
            })
    }


    const handleSubmit = (e) => {
        sendSearch();
        e.preventDefault();
    }

    const sendSearch = () => {
        var path = ip + '/api/document/search';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []

                    for (let index = 0; index < result.data.length; index++) {
                        var z = document.createElement('div'); // is a node
                        var pers = result.data[index]
                        var i = pers.id
                        z.className = "listItem"
                        z.innerHTML = "<p align=\"left\">- "+pers.typeDocument + " "+ pers.seriaDocument + " " +pers.numberDocument;
                        z.style.display = "block";
                        const cl = i => () => {
                            sendDocument(i)
                        }
                        const dblcl = i => () => {
                            sendDocumentFullScreen(i)
                        }
                        //z.onclick = cl(pers.id)
                        z.ondblclick = dblcl(pers.id)
                        var per = new DocumentModel()
                        per.id = pers.id
                        z.value = per
                        zz.push(z);
                    }
                    changeSearch(zz)
                }
            })
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }
    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id)
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "List").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "List").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id).value = l[index]
                            document.getElementById(id + "List").innerHTML = "";

                           
                              if(id=='typeDocument'){
                                personModel.typeDocument = l[index]
                              }
                              if(id=='numberDocument'){
                                personModel.numberDocument = l[index]
                              }
                              if(id=='seriaDocument'){
                                personModel.seriaDocument = l[index]
                              }
                              if(id=='descDocument'){
                                personModel.descDocument = l[index]
                              }

                        }
                        document.getElementById(id + "List").appendChild(z);

                    }
                }
            })








    }


        
      const typeDocumentchange = () => {
        personModel.typeDocument = document.getElementById('typeDocument').value
        changedfield('typeDocument');
      }
    
      const numberDocumentchange = () => {
        personModel.numberDocument = document.getElementById('numberDocument').value
        changedfield('numberDocument');
      }
    
      const seriaDocumentchange = () => {
        personModel.seriaDocument = document.getElementById('seriaDocument').value
        changedfield('seriaDocument');
      }
    
      const descDocumentchange = () => {
        personModel.descDocument = document.getElementById('descDocument').value
        changedfield('descDocument');
      }


    const handleFocus = (event) => {
        closeAllHelp()
    };

    return (
        <div>
            <button id="clear-button-document" className="clear-button-right" onClick={clearSubmit}>Очистити
            </button>
            <button id="add-button-document" className="add-button-right" onClick={addSubmit}>Додати
            </button>
            <form onSubmit={handleSubmit} className="form">
                <input id="input-button-document" className="input-button-right" type="submit" value="Пошук" />

          
          <div id="descDocumentDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="descDocument" className="input-text" tabIndex="4" name="login" type="text" onChange={descDocumentchange}  placeholder="Опис" autoComplete="off"  onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="descDocumentList" className="list" />
          </div>

          <div id="seriaDocumentDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="seriaDocument" className="input-text" tabIndex="3" name="login" type="text" onChange={seriaDocumentchange}  placeholder="Серія" autoComplete="off"  onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="seriaDocumentList" className="list" />
          </div>

          <div id="numberDocumentDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="numberDocument" className="input-text" tabIndex="2" name="login" type="text" onChange={numberDocumentchange}  placeholder="Номер" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="numberDocumentList" className="list" />
          </div>

          <div id="typeDocumentDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="typeDocument" className="input-text" tabIndex="1" name="login" type="text" onChange={typeDocumentchange}  placeholder="Тип документа" autoComplete="off"  onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="typeDocumentList" className="list" />
          </div>



            </form>
        </div>
    );
}

export default Document;